module.exports = __webpack_public_path__ + "img/dd.ebe64830.svg";